import {client} from '../helpers/api';

export async function getCities() {
  const response = await client.get('/v1/cities');

  if (response.data?.status) {
    return (
      response.data?.data.map(({city_id: id, city_name: name}) => ({
        id,
        name,
      })) || []
    );
  }
  throw response;
}

// {
//   "city_id": "24510600-d5ac-431c-843a-dac50be1392d",
//   "city_name": "Alor Setar"
// }
